const PURCHASE_STATE = {
    PENDING: 'PENDING',
    PAID: 'PAID',
    CONFIRMED: 'CONFIRMED',
    JOSE: 'JOSE',
    DISBURSED: 'DISBURSED',
};

export default PURCHASE_STATE;
